import axios from 'axios';
import errorHandler from './ErrorHandler';

const METHOD_TYPES = {
  POST: 'POST',
  GET: 'GET'
};

class BaseService {
  ajax(configRequest) {
    return axios({ headers: { 'X-Requested-With': 'XMLHttpRequest' }, ...configRequest })
      .then((request) => {
        if (request.data && request.data.error) {
          throw request.data.error;
        }
        return request.data;
      })
      .catch((error) => errorHandler.handle(error.response));
  }

  get(url, params = {}) {
    const getConfigRequest = {
      method: METHOD_TYPES.GET.toLowerCase(),
      url,
      params: { cache: Date.now(), ...params }
    };
    return this.ajax(getConfigRequest);
  }

  post(url, data = {}) {
    const postConfigRequest = {
      method: METHOD_TYPES.POST.toLowerCase(),
      url,
      data
    };
    return this.ajax(postConfigRequest);
  }

  all(arrPromises) {
    return axios.all(arrPromises);
  }
}

BaseService.METHOD_TYPES = METHOD_TYPES;

export default BaseService;



// WEBPACK FOOTER //
// ./src/services/BaseService.js